// extracted by mini-css-extract-plugin
export var active = "_k-9";
export var backButton = "_k-8";
export var clone = "_k-e";
export var collapseBar = "_k-k";
export var collapseMode = "_k-m";
export var collapsed = "_k-o";
export var dimmed = "_k-i";
export var dragHandle = "_k-c";
export var dropdownIcon = "_k-g";
export var expanding = "_k-n";
export var hidden = "_k-x";
export var iconContainer = "_k-q";
export var iconSwapper = "_k-w";
export var navItem = "_k-6";
export var navItemIcon = "_k-f";
export var navProfile = "_k-7";
export var notificationCountBadge = "_k-j";
export var notificationDot = "_k-r";
export var optionsContainer = "_k-h";
export var primaryNav = "_k-0";
export var primaryNavDivider = "_k-v";
export var primaryNavResizeHandle = "_k-2";
export var primaryNavResizing = "_k-1";
export var primaryNavTabSection = "_k-u";
export var primaryTab = "_k-p";
export var primaryTabIconBox = "_k-s";
export var secondaryNav = "_k-3";
export var selected = "_k-t";
export var settingsNav = "_k-4";
export var settingsNavItems = "_k-5";
export var show = "_k-d";
export var sideNav = "_k-l";
export var teamItem = "_k-a";
export var userProfileItem = "_k-b";